
import {
    NinchatProperties,
    NinchatState,
} from 'api/types'
import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatQueuePartedEvent} from '../types/events'

import {
    extractProperties,
} from '.'

export const queueParted: CaseReducer<NinchatState> = (state, action) => {
    const {queue_id} = extractProperties<NinchatQueuePartedEvent>(action.payload)

    // When I was removed from queue
    const myUserId = state.user_id || ''

    state._queues ??= {}
    state._queues[queue_id] = {...state.user_queues?.[queue_id]} as NinchatProperties.NinchatUserQueue

    delete state._queues?.[queue_id]?.queue_members?.[myUserId]

    delete state.user_queues?.[queue_id]
}
